import type { PageLoad } from './$types';

export const prerender = true;

export const load = (() => ({
  title: 'Sign-up | pome',
})) satisfies PageLoad;
